// Maybe the file contents for the current environment will overwrite these during build.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { IEnvironment } from './environment.iface';

export const environment: IEnvironment = {
  ...(window as any).bootstrapSettings,
};
